var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.375 6.75H10.125C9.97726 6.75 9.83097 6.7791 9.69448 6.83563C9.55799 6.89217 9.43397 6.97504 9.3295 7.0795C9.22504 7.18397 9.14217 7.30799 9.08563 7.44448C9.0291 7.58097 9 7.72726 9 7.875V11.25H25.875C26.0227 11.25 26.169 11.2791 26.3055 11.3356C26.442 11.3922 26.566 11.475 26.6705 11.5795C26.775 11.684 26.8578 11.808 26.9144 11.9445C26.9709 12.081 27 12.2273 27 12.375V24.75H30.375C30.5227 24.75 30.669 24.7209 30.8055 24.6644C30.942 24.6078 31.066 24.525 31.1705 24.4205C31.275 24.316 31.3578 24.192 31.4144 24.0555C31.4709 23.919 31.5 23.7727 31.5 23.625V7.875C31.5 7.72726 31.4709 7.58097 31.4144 7.44448C31.3578 7.30799 31.275 7.18397 31.1705 7.0795C31.066 6.97504 30.942 6.89217 30.8055 6.83563C30.669 6.7791 30.5227 6.75 30.375 6.75Z",
    fill: "#1B1B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 11.25H5.625C5.00368 11.25 4.5 11.7537 4.5 12.375V28.125C4.5 28.7463 5.00368 29.25 5.625 29.25H25.875C26.4963 29.25 27 28.7463 27 28.125V12.375C27 11.7537 26.4963 11.25 25.875 11.25Z",
    stroke: "#1B1B26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25V7.875C9 7.57663 9.11853 7.29048 9.3295 7.07951C9.54048 6.86853 9.82663 6.75 10.125 6.75H30.375C30.6734 6.75 30.9595 6.86853 31.1705 7.07951C31.3815 7.29048 31.5 7.57663 31.5 7.875V23.625C31.5 23.9234 31.3815 24.2095 31.1705 24.4205C30.9595 24.6315 30.6734 24.75 30.375 24.75H27",
    stroke: "#1B1B26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.75H27",
    stroke: "#1B1B26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/browser_icon.81fd7f35cf77eece666f9d39c8ce01fa.svg";
export { ForwardRef as ReactComponent };